module.exports = __webpack_public_path__ + "media/images/ohap_gradebook_on-4073545d41a32e2d129d688f747f3065.png";